// the API takes any name, and the browser reads only IANA zones
export function isTimeZone(timeZone: string): boolean {
  try {
    return Boolean(Intl.DateTimeFormat(undefined, { timeZone }));
  } catch {
    return false;
  }
}

export function timeZoneName(
  date: Date,
  timeZone: string,
  style: 'short' | 'long' = 'short',
  locale?: string,
): string | undefined {
  return new Intl.DateTimeFormat(locale, { timeZone, timeZoneName: style })
    .formatToParts(date)
    .find((part) => part.type === 'timeZoneName')?.value;
}

export function timeZoneLabel(
  date: Date,
  timeZone: string,
): string | undefined {
  if (timeZone === Intl.DateTimeFormat().resolvedOptions().timeZone) {
    return undefined;
  }

  return timeZoneName(date, timeZone);
}
